import { ElementRef, Injectable, NgZone } from '@angular/core';
import { merge, Observable, of } from 'rxjs';
import { distinctUntilChanged, exhaustMap, map, take } from 'rxjs/operators';
import { async } from '../rx/util';
import { ContentService } from './content.service';
import { EventsService } from './events.service';
import { runInZone } from './zone';

export interface Size {
  width: number;
  height: number;
}

@Injectable()
export class SizeService {
  constructor(
    private readonly contentService: ContentService,
    private readonly element: ElementRef<HTMLElement>,
    private readonly eventService: EventsService,
    private readonly zone: NgZone,
  ) {}

  readonly size: Observable<Size> = merge(
    of(undefined),
    this.eventService.resize,
    this.contentService.observe(this.element.nativeElement),
  ).pipe(
    exhaustMap(() =>
      this.zone.isStable ? of(undefined) : this.zone.onStable.pipe(take(1)),
    ),
    runInZone(this.zone),
    async(),
    map(() => ({
      width: this.element.nativeElement.clientWidth,
      height: this.element.nativeElement.clientHeight,
    })),
    distinctUntilChanged(
      (a, b) => a.width === b.width && a.height === b.height,
    ),
  );
}
